import React from 'react';

import { useTranslation } from '@/i18n';
import PageLayout from '@/components/layout/PageLayout';
import RecalculoFilters from '@/components/features/attendance/recalculation/RecalculoFilters';
import LastProcessSection from '@/components/features/attendance/recalculation/LastProcessSection';
import ProcessHistorySection from '@/components/features/attendance/recalculation/ProcessHistorySection';
import { useRecalculationStatus } from '@/hooks/attendance/recalculation/useRecalculationStatus';
import { useRecalculoProcess } from '@/hooks/attendance/recalculation/useRecalculoProcess';


export const RecalculoAsistencia: React.FC = () => {
  const { t: translate } = useTranslation();
  const { isRecalculating, processStatus } = useRecalculationStatus();
  const { handleRecalculate, handleStop } = useRecalculoProcess();

  return (
    <PageLayout dynamicTitle={translate('attendance:recalculo.title')}>
      <div className="flex flex-col gap-6" data-testid="recalculo-asistencia-page">
        <RecalculoFilters
          isRecalculating={isRecalculating}
          onRecalculate={handleRecalculate}
          onStop={handleStop}
        />
        <LastProcessSection processStatus={processStatus} />
        <ProcessHistorySection />
      </div>
    </PageLayout>
  );
};

export default RecalculoAsistencia;
